export default "__VITE_ASSET__CKzDSzfn__"